/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const Q_buff_ally = require('./Q_buff_ally');
const Q_full_AP = require('./Q_full_AP');
const UseAbility = require('../UseAbility');
const BattleCalc = require('../../BattleCalc');
const AStarSearch = require('../../ai/AStarSearch/AStarSearch');

const Q_ally_no_poisoner = function (actor, battleState) {
  const node = new Q_buff_ally('poison_weapon', actor, battleState);

  node.branches[node.NO] = new Q_full_AP(actor, battleState);
  node.branches[node.YES] = new UseAbility(actor, 'poison_weapon');

  node.poison_weapon = BattleCalc.getEquippedAbility(actor, 'poison_weapon');
  node.leap = BattleCalc.getEquippedAbility(actor, 'leap');
  node.teleport = BattleCalc.getEquippedAbility(actor, 'teleport');
  node.move = BattleCalc.getEquippedAbility(actor, 'move');

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.poison_weapon = null;
    node.leap = null;
    node.teleport = null;
    node.move = null;
    originalDispose.call(node);
  };

  node.getUnitWithoutBuff = function () {
    const blessedFactor = BattleCalc.getBlessedFactor(actor);

    for (const ally of BattleCalc.getAlliesOfUnit(
      actor,
      battleState.allUnits
    )) {
      // ally must have a weapon equipped (weapon in right hand, or bow in left hand)
      const hasWeapon = ally.equipment.weapon ||
                        (ally.equipment.off_hand && ally.equipment.off_hand.type === 'bow');

      if (
        !BattleCalc.getCondition(ally, node.buffCondition) &&
        hasWeapon &&
        // ally is adjacent or can be reached by leap/teleport
        (BattleCalc.adjacent(actor, ally) ||
          ((node.leap || node.teleport) && !BattleCalc.isSurrounded(ally, battleState)) ||
          // has enough AP to move to ally and poison weapon (and there is a path)
          (actor.ap >
            BattleCalc.boardDistance(actor, ally) *
              node.move.apCost *
              blessedFactor +
              node.poison_weapon.apCost * blessedFactor &&
            AStarSearch(actor, ally, battleState).length > 1))
      ) {
        return ally;
      }
    }

    return null;
  };

  return node;
};
module.exports = Q_ally_no_poisoner;
